import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home-doctor',
  imports: [
    FormsModule,
    MatIconModule,
    MatRadioModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    CommonModule,
  ],
  templateUrl: './home-doctor.component.html',
  styleUrl: './home-doctor.component.scss'
})
export class HomeDoctorComponent implements OnInit {
  progressValue = 50; // Paso 1 de 3
  selectedCategory = 'Medicina General';
  selectedAddress = '';
  isCovid = false;

  categories = [
    'Medicina General',
    'Pediatría'
  ];

  ngOnInit() {
    // Forzar que el valor inicial se muestre en el mat-select
    setTimeout(() => {
      this.selectedCategory = 'Medicina General';
    }, 0);
  }

  goToNextStep() {
    console.log('Confirmar dirección - Siguiente paso');
    console.log('Categoría:', this.selectedCategory);
    console.log('Dirección:', this.selectedAddress);
    console.log('Es COVID:', this.isCovid);
  }
}
